module.exports = __webpack_public_path__ + "img/failAudit.f8613895.png";